import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Hero from '../components/Heroimg2';
import PricingCard from '../components/PricingCard';
import Work from '../components/Work';



function Projects() {
  return (
    <div>
      <Navbar/>
      <Hero heading= "PROJECTS." text="Some of my most recent works."/>
      <Work/>
      <PricingCard/>
      <Footer/>
    </div>
  )
}

export default Projects